import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" }
const _hoisted_3 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3" }
const _hoisted_4 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "bg-white border border-gray-200 rounded-xl shadow-sm p-4 mb-6" }
const _hoisted_7 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "mt-3 flex justify-end"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3"
}
const _hoisted_14 = { class: "text-sm text-red-800" }
const _hoisted_15 = {
  key: 1,
  class: "flex items-center justify-center py-20"
}
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6" }
const _hoisted_17 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_18 = { class: "flex items-center justify-between mb-2" }
const _hoisted_19 = { class: "p-2.5 bg-[#22282F]/10 rounded-xl" }
const _hoisted_20 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_21 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_22 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_23 = { class: "flex items-center justify-between mb-2" }
const _hoisted_24 = { class: "p-2.5 bg-blue-50 rounded-xl" }
const _hoisted_25 = { class: "text-xs text-gray-400" }
const _hoisted_26 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_27 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_28 = { class: "flex items-center justify-between mb-2" }
const _hoisted_29 = { class: "p-2.5 bg-green-50 rounded-xl" }
const _hoisted_30 = { class: "text-xs text-gray-400" }
const _hoisted_31 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_32 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_33 = { class: "flex items-center justify-between mb-2" }
const _hoisted_34 = { class: "p-2.5 bg-amber-50 rounded-xl" }
const _hoisted_35 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_36 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_37 = { class: "mb-3 mt-2 flex items-center gap-2" }
const _hoisted_38 = { class: "text-xs text-gray-400" }
const _hoisted_39 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-6 mb-6" }
const _hoisted_40 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_41 = { class: "flex items-center justify-between mb-2" }
const _hoisted_42 = { class: "p-2.5 bg-indigo-50 rounded-xl" }
const _hoisted_43 = { class: "text-xs text-gray-400" }
const _hoisted_44 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_45 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_46 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_47 = { class: "flex items-center justify-between mb-2" }
const _hoisted_48 = { class: "p-2.5 bg-[#22282F]/10 rounded-xl" }
const _hoisted_49 = { class: "text-xs text-gray-400" }
const _hoisted_50 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_51 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_52 = { class: "flex items-center justify-between mb-2" }
const _hoisted_53 = { class: "p-2.5 bg-gray-100 rounded-xl" }
const _hoisted_54 = { class: "text-xs text-gray-400" }
const _hoisted_55 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_56 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_57 = { class: "flex items-center justify-between mb-2" }
const _hoisted_58 = { class: "p-2.5 bg-blue-50 rounded-xl" }
const _hoisted_59 = { class: "text-xs text-gray-400" }
const _hoisted_60 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_61 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_62 = { class: "flex items-center justify-between mb-2" }
const _hoisted_63 = { class: "p-2.5 bg-green-50 rounded-xl" }
const _hoisted_64 = { class: "text-xs text-gray-400" }
const _hoisted_65 = { class: "text-3xl font-bold text-gray-900" }
const _hoisted_66 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_67 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm mb-6" }
const _hoisted_68 = { class: "text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2" }
const _hoisted_69 = { class: "h-64" }
const _hoisted_70 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" }
const _hoisted_71 = { class: "lg:col-span-2 bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_72 = { class: "text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2" }
const _hoisted_73 = { class: "h-64" }
const _hoisted_74 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_75 = { class: "text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2" }
const _hoisted_76 = { class: "h-64 flex items-center justify-center" }
const _hoisted_77 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" }
const _hoisted_78 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_79 = { class: "text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2" }
const _hoisted_80 = { class: "h-64" }
const _hoisted_81 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_82 = { class: "text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2" }
const _hoisted_83 = { class: "h-64" }
const _hoisted_84 = { class: "bg-white border border-gray-200 rounded-xl p-5 shadow-sm" }
const _hoisted_85 = { class: "text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2" }
const _hoisted_86 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_87 = { class: "flex-1 min-w-0" }
const _hoisted_88 = { class: "flex items-center justify-between gap-2 mb-1" }
const _hoisted_89 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_90 = { class: "text-xs text-gray-500 flex-shrink-0" }
const _hoisted_91 = { class: "h-1.5 bg-gray-100 rounded-full overflow-hidden" }
const _hoisted_92 = {
  key: 0,
  class: "text-xs text-gray-400 mt-1"
}
const _hoisted_93 = {
  key: 1,
  class: "text-sm text-gray-400 py-6 text-center"
}

import { ref, computed, onMounted, watch } from 'vue'
import { defineComponent, h } from 'vue'
import {
  BarChart3, RefreshCw, AlertCircle, Users, LogIn, UserCheck, Clock,
  TrendingUp, PieChart, Activity, CalendarDays, Trophy,
  Workflow, Percent, FileText, Send, ClipboardList, CheckCircle2, X,
} from 'lucide-vue-next'
import { Bar, Line, Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale,
  LinearScale, PointElement, LineElement, ArcElement, Filler,
} from 'chart.js'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { useToast } from '@/utils/toast'
import {
  fetchAuditLogs, fetchUserMap, filterLogs, dayRange, loginsPerDay,
  loginsPerHour, loginsPerWeekday, distinctUsers, todayStats, buildSessions,
  avgSessionMs, totalSessionMs, topUsers, loginsPerAmbassade, formatDuration,
  listAmbassades, listRoles, listDirections, listUsers,
} from '@/utils/loginStats'
import type { AuditLog, UserMap, UserInfo } from '@/utils/loginStats'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatistiquesView',
  setup(__props) {

ChartJS.register(
  Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
  PointElement, LineElement, ArcElement, Filler,
)

// Petit composant d'état vide pour les graphiques
const EmptyChart = defineComponent({
  setup() {
    return () => h('div', { class: 'h-full w-full flex items-center justify-center text-sm text-gray-400' }, 'Aucune donnée sur la période')
  },
})

const toast = useToast()

const loading = ref(true)
const error = ref('')
// period : 1/7/30/90 = presets glissants ; 0 = intervalle personnalisé (customFrom/customTo)
const period = ref<number>(7)
const customFrom = ref<string>('')
const customTo = ref<string>('')
const ambassadeId = ref<number | null>(null)
const directionId = ref<number | null>(null)
const roleCode = ref<string | null>(null)
const userId = ref<number | null>(null)

const userMap = ref<UserMap>({})
const rawLogins = ref<AuditLog[]>([])
const rawLogouts = ref<AuditLog[]>([])
// Activité plateforme (mêmes filtres ambassade/rôle appliqués côté client)
const rawNotesCreated = ref<AuditLog[]>([])
const rawNotesSubmitted = ref<AuditLog[]>([])
const rawValidations = ref<AuditLog[]>([])
const rawAffCreated = ref<AuditLog[]>([])
const rawAffTreated = ref<AuditLog[]>([])

const ambassades = computed(() => listAmbassades(userMap.value))
const directions = computed(() => listDirections(userMap.value))
const roles = computed(() => listRoles(userMap.value))
const usersList = computed(() => listUsers(userMap.value))

const hasActiveFilters = computed(() =>
  Boolean(ambassadeId.value || directionId.value || roleCode.value || userId.value),
)

const periodLabel = computed(() => {
  if (period.value === 0) {
    if (customFrom.value && customTo.value) return `${customFrom.value} → ${customTo.value}`
    return 'intervalle personnalisé'
  }
  if (period.value === 1) return "aujourd'hui"
  return `${period.value} j`
})

// Critères de filtrage client (ambassade / direction / rôle / agent)
const filterOpts = computed(() => ({
  ambassadeId: ambassadeId.value,
  directionId: directionId.value,
  roleCode: roleCode.value,
  userId: userId.value,
}))

// Logs filtrés selon le périmètre
const logins = computed(() =>
  filterLogs(rawLogins.value, userMap.value, filterOpts.value),
)
const logouts = computed(() =>
  filterLogs(rawLogouts.value, userMap.value, filterOpts.value),
)

// Activité plateforme filtrée selon le périmètre
const applyFilter = (logs: AuditLog[]) =>
  filterLogs(logs, userMap.value, filterOpts.value)
const notesCreated = computed(() => applyFilter(rawNotesCreated.value))
const notesSubmitted = computed(() => applyFilter(rawNotesSubmitted.value))
const validations = computed(() => applyFilter(rawValidations.value))
const affCreated = computed(() => applyFilter(rawAffCreated.value))
const affTreated = computed(() => applyFilter(rawAffTreated.value))

const hasData = computed(() => logins.value.length > 0)

const sessions = computed(() => buildSessions(logins.value, logouts.value))

const kpi = computed(() => {
  const today = todayStats(logins.value)
  return {
    todayUsers: today.users,
    todayTotal: today.total,
    totalLogins: logins.value.length,
    activeUsers: distinctUsers(logins.value),
    avgSession: formatDuration(avgSessionMs(sessions.value)),
    totalUsage: formatDuration(totalSessionMs(sessions.value)),
  }
})

// Nombre de comptes correspondant au périmètre, pour le taux de connexion
const totalAccounts = computed(() => {
  const all: UserInfo[] = Object.values(userMap.value)
  if (!hasActiveFilters.value) return all.length
  return all.filter((u) =>
    (!ambassadeId.value || u.ambassade?.id === ambassadeId.value) &&
    (!directionId.value || u.direction?.id === directionId.value) &&
    (!roleCode.value || u.role?.code === roleCode.value) &&
    (!userId.value || u.id === userId.value),
  ).length
})

// KPIs d'activité plateforme (sur la période, dérivés des actions auditées)
const activity = computed(() => {
  const notesValidees = validations.value.length
  const affTraitees = affTreated.value.length
  const total = totalAccounts.value
  const actifs = distinctUsers(logins.value)
  return {
    tauxConnexion: total > 0 ? Math.round((actifs / total) * 100) : 0,
    actifs,
    total,
    notesCreated: notesCreated.value.length,
    notesSubmitted: notesSubmitted.value.length,
    affCreated: affCreated.value.length,
    notesValidees,
    affTraitees,
    workflowsValides: notesValidees + affTraitees,
  }
})

const top = computed(() => topUsers(logins.value, userMap.value, 5))
const maxTop = computed(() => (top.value.length ? top.value[0].count : 1))
const barWidth = (count: number) => `${Math.round((count / maxTop.value) * 100)}%`

// ---- Période -> dates ----
function periodRange(): { from: Date; to: Date } {
  // Intervalle personnalisé
  if (period.value === 0 && customFrom.value && customTo.value) {
    const from = new Date(customFrom.value)
    from.setHours(0, 0, 0, 0)
    const to = new Date(customTo.value)
    to.setHours(23, 59, 59, 999)
    return { from, to }
  }
  // Presets glissants (1/7/30/90) — fallback 7 j si custom incomplet
  const days = period.value > 0 ? period.value : 7
  const to = new Date()
  const from = new Date()
  from.setDate(from.getDate() - (days - 1))
  from.setHours(0, 0, 0, 0)
  return { from, to }
}

function resetFilters() {
  ambassadeId.value = null
  directionId.value = null
  roleCode.value = null
  userId.value = null
}

// ---- Données des graphiques ----
const PALETTE = ['#22282F', '#8C0004', '#4B5563', '#9CA3AF', '#1D4ED8', '#059669', '#D97706', '#7C3AED', '#DB2777', '#0891B2']

const lineData = computed(() => {
  const { from, to } = periodRange()
  const keys = dayRange(from, to)
  const perDay = loginsPerDay(logins.value)
  return {
    labels: keys.map((k) => {
      const d = new Date(k)
      return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })
    }),
    datasets: [{
      label: 'Connexions',
      data: keys.map((k) => perDay[k] || 0),
      borderColor: '#22282F',
      backgroundColor: 'rgba(34,40,47,0.08)',
      fill: true,
      tension: 0.35,
      pointRadius: 3,
      pointBackgroundColor: '#22282F',
    }],
  }
})

const hourData = computed(() => ({
  labels: Array.from({ length: 24 }, (_, h2) => `${String(h2).padStart(2, '0')}h`),
  datasets: [{
    label: 'Connexions',
    data: loginsPerHour(logins.value),
    backgroundColor: '#22282F',
    borderRadius: 4,
    maxBarThickness: 18,
  }],
}))

const weekdayData = computed(() => ({
  labels: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
  datasets: [{
    label: 'Connexions',
    data: loginsPerWeekday(logins.value),
    backgroundColor: '#8C0004',
    borderRadius: 4,
    maxBarThickness: 32,
  }],
}))

const doughnutData = computed(() => {
  const grouped = loginsPerAmbassade(logins.value, userMap.value)
  const entries = Object.entries(grouped).sort((a, b) => b[1] - a[1]).slice(0, 10)
  return {
    labels: entries.map((e) => e[0]),
    datasets: [{
      data: entries.map((e) => e[1]),
      backgroundColor: entries.map((_, i) => PALETTE[i % PALETTE.length]),
      borderWidth: 2,
      borderColor: '#fff',
    }],
  }
})

const activityData = computed(() => ({
  labels: ['Notes créées', 'Notes soumises', 'Affectations créées', 'Notes validées', 'Affectations traitées'],
  datasets: [{
    label: 'Événements',
    data: [
      activity.value.notesCreated,
      activity.value.notesSubmitted,
      activity.value.affCreated,
      activity.value.notesValidees,
      activity.value.affTraitees,
    ],
    backgroundColor: ['#22282F', '#4B5563', '#1D4ED8', '#059669', '#D97706'],
    borderRadius: 4,
    maxBarThickness: 48,
  }],
}))
const hasActivity = computed(() =>
  activity.value.notesCreated + activity.value.notesSubmitted + activity.value.affCreated +
  activity.value.notesValidees + activity.value.affTraitees > 0,
)

const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
}
const lineOptions = { ...baseOptions, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } }
const hourOptions = { ...baseOptions, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } }
const weekdayOptions = { ...baseOptions, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } }
const activityOptions = { ...baseOptions, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } }
const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '62%',
  plugins: { legend: { position: 'bottom' as const, labels: { boxWidth: 12, font: { size: 11 } } } },
}

// ---- Chargement ----
async function load() {
  loading.value = true
  error.value = ''
  try {
    const { from, to } = periodRange()
    const fromISO = from.toISOString()
    const toISO = to.toISOString()
    const [map, lins, louts, nCreated, nSubmitted, vals, aCreated, aTreated] = await Promise.all([
      Object.keys(userMap.value).length ? Promise.resolve(userMap.value) : fetchUserMap(),
      fetchAuditLogs('auth.login_success', fromISO, toISO),
      fetchAuditLogs('auth.logout', fromISO, toISO),
      fetchAuditLogs('note.creee', fromISO, toISO),
      fetchAuditLogs('note.soumise', fromISO, toISO),
      fetchAuditLogs('validation.validee', fromISO, toISO),
      fetchAuditLogs('affectation.creee', fromISO, toISO),
      fetchAuditLogs('affectation.traitee', fromISO, toISO),
    ])
    userMap.value = map
    rawLogins.value = lins
    rawLogouts.value = louts
    rawNotesCreated.value = nCreated
    rawNotesSubmitted.value = nSubmitted
    rawValidations.value = vals
    rawAffCreated.value = aCreated
    rawAffTreated.value = aTreated
  } catch (e: any) {
    error.value = "Impossible de charger les statistiques de connexion"
    toast.error('Erreur', e?.message || 'Chargement des statistiques échoué')
  } finally {
    loading.value = false
  }
}

function refresh() {
  userMap.value = {}
  load()
}

// Recharger les logs quand la fenêtre temporelle change. Les filtres
// périmètre (ambassade/direction/rôle/agent) sont appliqués côté client
// sans refetch.
let rangeDebounce: ReturnType<typeof setTimeout> | undefined
watch(period, (p) => {
  // À l'entrée en mode personnalisé, pré-remplir un intervalle par défaut (30 j).
  if (p === 0 && (!customFrom.value || !customTo.value)) {
    const to = new Date()
    const from = new Date(to.getTime() - 30 * 24 * 3600 * 1000)
    customFrom.value = from.toISOString().slice(0, 10)
    customTo.value = to.toISOString().slice(0, 10)
  }
  load()
})
watch([customFrom, customTo], () => {
  if (period.value !== 0) return
  if (!customFrom.value || !customTo.value) return
  if (rangeDebounce) clearTimeout(rangeDebounce)
  rangeDebounce = setTimeout(() => load(), 300)
})

onMounted(load)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(BarChart3), { class: "w-7 h-7 sm:w-8 sm:h-8 text-[#22282F]" })
              ]),
              _cache[7] || (_cache[7] = _createTextVNode(" Statistiques de connexion "))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-500 mt-2" }, "Analyse des connexions à partir des journaux d'audit", -1))
          ]),
          _createElementVNode("button", {
            onClick: refresh,
            disabled: loading.value,
            class: "self-start sm:self-auto px-4 py-2 bg-[#22282F] text-white rounded-lg hover:bg-[#2a3139] transition-colors flex items-center gap-2 disabled:opacity-50"
          }, [
            _createVNode(_unref(RefreshCw), {
              class: _normalizeClass(['w-4 h-4', loading.value && 'animate-spin'])
            }, null, 8, ["class"]),
            _cache[9] || (_cache[9] = _createTextVNode(" Actualiser "))
          ], 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Période", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("option", { value: 1 }, "Aujourd'hui", -1),
                _createElementVNode("option", { value: 7 }, "7 derniers jours", -1),
                _createElementVNode("option", { value: 30 }, "30 derniers jours", -1),
                _createElementVNode("option", { value: 90 }, "90 derniers jours", -1),
                _createElementVNode("option", { value: 0 }, "Personnalisé…", -1)
              ]), 512), [
                [
                  _vModelSelect,
                  period.value,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            (period.value === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Du", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customFrom).value = $event)),
                      type: "date",
                      class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
                    }, null, 512), [
                      [_vModelText, customFrom.value]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Au", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customTo).value = $event)),
                      type: "date",
                      class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
                    }, null, 512), [
                      [_vModelText, customTo.value]
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Ambassade", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ambassadeId).value = $event)),
                class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Toutes", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ambassades.value, (a) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: a.id,
                    value: a.id
                  }, _toDisplayString(a.nom), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, ambassadeId.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Direction", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((directionId).value = $event)),
                class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "Toutes", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directions.value, (d) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: d.id,
                    value: d.id
                  }, _toDisplayString(d.nom), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, directionId.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Rôle", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((roleCode).value = $event)),
                class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "Tous", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (r) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: r.code,
                    value: r.code
                  }, _toDisplayString(r.nom), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, roleCode.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-500 mb-1.5" }, "Agent", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userId).value = $event)),
                class: "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-[#22282F] focus:ring-2 focus:ring-[#22282F]/15"
              }, [
                _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "Tous", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersList.value, (u) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: u.id,
                    value: u.id
                  }, _toDisplayString(u.name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, userId.value]
              ])
            ])
          ]),
          (hasActiveFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: resetFilters,
                  class: "px-3 py-2 text-sm text-gray-500 hover:text-[#22282F] border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-1.5"
                }, [
                  _createVNode(_unref(X), { class: "w-4 h-4" }),
                  _cache[22] || (_cache[22] = _createTextVNode(" Réinitialiser les filtres "))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_unref(AlertCircle), { class: "w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" }),
              _createElementVNode("p", _hoisted_14, _toDisplayString(error.value), 1)
            ]))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[23] || (_cache[23] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", { class: "w-12 h-12 border-4 border-[#22282F]/30 border-t-[#22282F] rounded-full animate-spin mx-auto mb-4" }),
                _createElementVNode("p", { class: "text-gray-500" }, "Chargement des statistiques…")
              ], -1)
            ])))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_unref(Users), { class: "w-5 h-5 text-[#22282F]" })
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "Aujourd'hui", -1))
                  ]),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(kpi.value.todayUsers), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "personnes connectées aujourd'hui", -1)),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(kpi.value.todayTotal) + " connexion(s) au total", 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_unref(LogIn), { class: "w-5 h-5 text-blue-600" })
                    ]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(kpi.value.totalLogins), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "connexions sur la période", -1))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_unref(UserCheck), { class: "w-5 h-5 text-green-600" })
                    ]),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(kpi.value.activeUsers), 1),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "utilisateurs actifs distincts", -1))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_unref(Clock), { class: "w-5 h-5 text-amber-600" })
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "moyenne", -1))
                  ]),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(kpi.value.avgSession), 1),
                  _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "durée moyenne de session", -1)),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(kpi.value.totalUsage) + " cumulées", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_unref(Workflow), { class: "w-5 h-5 text-[#22282F]" }),
                _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, "Activité de la plateforme", -1)),
                _createElementVNode("span", _hoisted_38, "· " + _toDisplayString(periodLabel.value), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_unref(Percent), { class: "w-5 h-5 text-indigo-600" })
                    ]),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(activity.value.tauxConnexion) + "%", 1),
                  _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "taux de connexion", -1)),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(activity.value.actifs) + " / " + _toDisplayString(activity.value.total) + " compte(s)", 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_unref(FileText), { class: "w-5 h-5 text-[#22282F]" })
                    ]),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(activity.value.notesCreated), 1),
                  _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "notes créées", -1))
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_unref(Send), { class: "w-5 h-5 text-gray-600" })
                    ]),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_55, _toDisplayString(activity.value.notesSubmitted), 1),
                  _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "notes soumises au workflow", -1))
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_unref(ClipboardList), { class: "w-5 h-5 text-blue-600" })
                    ]),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_60, _toDisplayString(activity.value.affCreated), 1),
                  _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "affectations créées", -1))
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_unref(CheckCircle2), { class: "w-5 h-5 text-green-600" })
                    ]),
                    _createElementVNode("span", _hoisted_64, _toDisplayString(periodLabel.value), 1)
                  ]),
                  _createElementVNode("p", _hoisted_65, _toDisplayString(activity.value.workflowsValides), 1),
                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-0.5" }, "workflows validés", -1)),
                  _createElementVNode("p", _hoisted_66, _toDisplayString(activity.value.notesValidees) + " note(s) · " + _toDisplayString(activity.value.affTraitees) + " affectation(s)", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("h3", _hoisted_68, [
                  _createVNode(_unref(BarChart3), { class: "w-4 h-4 text-[#22282F]" }),
                  _cache[36] || (_cache[36] = _createTextVNode(" Répartition de l'activité "))
                ]),
                _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-xs text-gray-400 mb-4" }, "Volume d'événements métier audités sur la période", -1)),
                _createElementVNode("div", _hoisted_69, [
                  (hasActivity.value)
                    ? (_openBlock(), _createBlock(_unref(Bar), {
                        key: 0,
                        data: activityData.value,
                        options: activityOptions
                      }, null, 8, ["data"]))
                    : (_openBlock(), _createBlock(_unref(EmptyChart), { key: 1 }))
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("h3", _hoisted_72, [
                    _createVNode(_unref(TrendingUp), { class: "w-4 h-4 text-[#22282F]" }),
                    _cache[38] || (_cache[38] = _createTextVNode(" Connexions par jour "))
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    (hasData.value)
                      ? (_openBlock(), _createBlock(_unref(Line), {
                          key: 0,
                          data: lineData.value,
                          options: lineOptions
                        }, null, 8, ["data"]))
                      : (_openBlock(), _createBlock(_unref(EmptyChart), { key: 1 }))
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("h3", _hoisted_75, [
                    _createVNode(_unref(PieChart), { class: "w-4 h-4 text-[#22282F]" }),
                    _cache[39] || (_cache[39] = _createTextVNode(" Répartition par ambassade "))
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    (hasData.value)
                      ? (_openBlock(), _createBlock(_unref(Doughnut), {
                          key: 0,
                          data: doughnutData.value,
                          options: doughnutOptions
                        }, null, 8, ["data"]))
                      : (_openBlock(), _createBlock(_unref(EmptyChart), { key: 1 }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("h3", _hoisted_79, [
                    _createVNode(_unref(Activity), { class: "w-4 h-4 text-[#22282F]" }),
                    _cache[40] || (_cache[40] = _createTextVNode(" Pics horaires de connexion "))
                  ]),
                  _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-xs text-gray-400 mb-4" }, "Nombre de connexions par heure de la journée", -1)),
                  _createElementVNode("div", _hoisted_80, [
                    (hasData.value)
                      ? (_openBlock(), _createBlock(_unref(Bar), {
                          key: 0,
                          data: hourData.value,
                          options: hourOptions
                        }, null, 8, ["data"]))
                      : (_openBlock(), _createBlock(_unref(EmptyChart), { key: 1 }))
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("h3", _hoisted_82, [
                    _createVNode(_unref(CalendarDays), { class: "w-4 h-4 text-[#22282F]" }),
                    _cache[42] || (_cache[42] = _createTextVNode(" Connexions par jour de semaine "))
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-xs text-gray-400 mb-4" }, "Identifie les journées les plus actives", -1)),
                  _createElementVNode("div", _hoisted_83, [
                    (hasData.value)
                      ? (_openBlock(), _createBlock(_unref(Bar), {
                          key: 0,
                          data: weekdayData.value,
                          options: weekdayOptions
                        }, null, 8, ["data"]))
                      : (_openBlock(), _createBlock(_unref(EmptyChart), { key: 1 }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("h3", _hoisted_85, [
                  _createVNode(_unref(Trophy), { class: "w-4 h-4 text-[#22282F]" }),
                  _cache[44] || (_cache[44] = _createTextVNode(" Utilisateurs les plus actifs "))
                ]),
                (top.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(top.value, (u, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: u.id,
                          class: "flex items-center gap-3"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["flex-shrink-0 w-6 h-6 rounded-full text-xs font-semibold flex items-center justify-center", i === 0 ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-600'])
                          }, _toDisplayString(i + 1), 3),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("p", _hoisted_89, _toDisplayString(u.name), 1),
                              _createElementVNode("span", _hoisted_90, _toDisplayString(u.count) + " connexion(s)", 1)
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", {
                                class: "h-full bg-[#22282F] rounded-full",
                                style: _normalizeStyle({ width: barWidth(u.count) })
                              }, null, 4)
                            ]),
                            (u.ambassade)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString(u.ambassade), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_93, "Aucune connexion sur la période."))
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})